import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import { createSector, fetchSector, removeSector } from '@/actions/sector';
import { notify } from '@/actions/ui';

import ModelForm from '../ModelForm';

function SectorModel({ id, model, fetchSector, createSector, removeSector, notify, sector }: any) {
  const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      (async (id) => {
        try {
          await fetchSector({ id });
        } catch (error) {
          // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
          notify(error.message, 'error');
          navigate(`/admin/${model.path}`);
        }
      })(id);
    }
  }, [id]);

  const editableFields = id ? [] : [{ name: 'name', type: 'text', maxLength: 60, required: true }];

  const handleSubmit = useCallback(async (values: any) => {
    const sector = await createSector(values);
    navigate(`/admin/${model.path}/${sector.id}`);
  }, []);

  const handleDelete = useCallback(() => removeSector(id), [id]);

  return (
    <ModelForm
      title={id ? `Sector ${id} - ${sector.name}` : 'Create new sector'}
      id={id}
      model={model}
      onSubmit={id ? null : handleSubmit}
      onDelete={handleDelete}
      initialModel={sector}
      fields={editableFields}
      returnPath={model.path}
    />
  );
}

// @ts-expect-error TS(2630) FIXME: Cannot assign to 'SectorModel' because it is a fun... Remove this comment to see the full error message
SectorModel = connect(
  (state, ownProps) => {
    return {
      // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
      sector: state.sectors.all.find((s: any) => s.id === ownProps.id) || {},
    };
  },
  {
    fetchSector,
    createSector,
    removeSector,
    notify,
  }
)(SectorModel);

export default SectorModel;
